import { useEffect, useState } from 'react';
import { useAuth } from '@clerk/react';
import { setClerkTokenGetter } from '../utils/authenticatedFetch';
import ActivateSoleOrganization from './ActivateSoleOrganization';
import DashboardLoadingScreen from './DashboardLoadingScreen';

interface AuthTokenBridgeProps {
  children: React.ReactNode;
}

const AuthTokenBridge = ({ children }: AuthTokenBridgeProps) => {
  const { getToken, isLoaded } = useAuth();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    setClerkTokenGetter(getToken);
    setIsReady(true);

    return () => setClerkTokenGetter(null);
  }, [getToken, isLoaded]);

  if (!isLoaded || !isReady) {
    return <DashboardLoadingScreen loadingMessage="Signing in securely..." />;
  }

  return <ActivateSoleOrganization>{children}</ActivateSoleOrganization>;
};

export default AuthTokenBridge;
